export default {
    createdAt: 'Created At',
    createdBy: 'Created By',
    canceled: 'Canceled',
    canceledBy: 'Canceled By',
    canceledAt: 'Canceled At',
}
